import React, { useState } from 'react';
import Snackbar from '../../Snackbar/Snackbar';
import useDevices from '../../../hooks/useDevices/useDevices';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

export function getSnackbarContent(hasAudio: boolean, hasVideo: boolean, error?: Error) {
  let headline = '';
  let message = '';

  switch (true) {
    // This error is emitted when the user or the user's system has denied permission to use the media devices
    case error?.name === 'NotAllowedError':
      headline = 'Görüntü ve Ses Kaynakları:';

      if (error!.message === 'Permission denied by system') {
        // Chrome only
        message = 'İşletim sistemi kamera ve mikrofon erişimine izin vermedi. Lütfen ayarlarınızı kontrol ediniz.';
      } else {
        message =
          'Kamera ve mikrofon erişimine izin vermediniz. Lütfen tarayıcınız üzerinden kamera ve mikrofon erişimine izin veriniz.';
      }

      break;

    // This error is emitted when input devices are not connected or disabled in the OS settings
    case error?.name === 'NotFoundError':
      headline = 'Kamera ve Mikrofon Bulunamadı:';
      message = 'Tarayıcınız tanımlı bir kamera ve mikrofon bulamadı. Lütfen ayarlarınızı kontrol ediniz.';
      break;

    // Other getUserMedia errors are less likely to happen in this app. Here we will display
    // the system's error message directly to the user.
    case Boolean(error):
      headline = 'Hata Oluştu:';
      message = `${error!.name} ${error!.message}`;
      break;

    case !hasAudio && !hasVideo:
      headline = 'Kamera ve Mikrofon Bulunamadı:';
      message = 'Sizi duyamayacaklar';
      break;

    case !hasVideo:
      headline = 'Kamera Bulunamadı:';
      message = 'Sizi göremeyecekler.';
      break;

    case !hasAudio:
      headline = 'Mikrofon Bulunamadı:';
      message = 'Sizi duyamayacaklar.';
  }

  return {
    headline,
    message,
  };
}

export default function MediaErrorSnackbar({ error }: { error?: Error }) {
  const { hasAudioInputDevices, hasVideoInputDevices } = useDevices();

  const { isAcquiringLocalTracks } = useVideoContext();

  const [isSnackbarDismissed, setIsSnackbarDismissed] = useState(false);

  const isSnackbarOpen =
    !isSnackbarDismissed &&
    !isAcquiringLocalTracks &&
    (Boolean(error) || !hasAudioInputDevices || !hasVideoInputDevices);

  const { headline, message } = getSnackbarContent(hasAudioInputDevices, hasVideoInputDevices, error);

  return (
    <Snackbar
      open={isSnackbarOpen}
      handleClose={() => setIsSnackbarDismissed(true)}
      headline={headline}
      message={message}
      variant="warning"
    />
  );
}
